import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  HalfContainer,
  OneThirdContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function SaleDetail(props: { forceShowDetail?: boolean }) {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const onViewOldData = ({ id, transactionType }) => {
    const params = {
      id,
    } as const;

    switch (transactionType) {
      case 'activity':
        navigate(NavigationRoutes.ActivitySalesView, params);
        break;
      case 'document':
        navigate(NavigationRoutes.TravelDocumentSalesView, params);
        break;
      case 'cruise':
        navigate(NavigationRoutes.CruiseSalesView, params);
        break;
      case 'flight':
        navigate(NavigationRoutes.TicketSalesView, params);
        break;
      case 'hotel':
        navigate(NavigationRoutes.HotelSalesView, params);
        break;
      case 'product':
        navigate(NavigationRoutes.ProductSalesView, params);
        break;
      case 'tour':
        navigate(NavigationRoutes.ToursalesView, params);
        break;

      default:
        break;
    }
  };

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">{t('ticketSales:sales-details')}</Text>
        <HOCInput keys={['approvalable']}>
          {(value) => {
            if (
              (value.approvalable.status === 'waiting' ||
                !value.approvalable.waitingId) &&
              !props.forceShowDetail
            ) {
              return <></>;
            }
            return (
              <Button
                buttonType="secondary"
                onClick={() => {
                  onViewOldData({
                    id: props.forceShowDetail
                      ? value.approvalable.id
                      : value.approvalable.waitingId,
                    transactionType: value.approvalable.transactionType,
                  });
                }}
              >
                {t('common:view_old_data')}
              </Button>
            );
          }}
        </HOCInput>
      </SectionContainer>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:date')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:invoice_number')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.code"
            label={t('common:group_code')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.description"
            label={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.customer"
            label={t('common:customer')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.customerBilling"
            label={t('common:billing_to')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <OneThirdContainer>
          <Input
            type="text"
            name="approvalable.admin"
            label={t('common:admin')}
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <Input
            type="text"
            name="approvalable.operator"
            label={t('common:operator')}
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <Input
            type="text"
            name="approvalable.salesman"
            label={t('common:sale_person')}
          />
        </OneThirdContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
